import { Accordion, Card, CardContent, useTheme } from "@material-ui/core";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: "0px 10px 23px rgba(0, 0, 0, 0.12)",
      width: "100%",
    },
    icon: {
      color: "#177739",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      color: "#177739",
      fontWeight: theme.typography.fontWeightBold as any,
    },
    acordionSummary: {
      paddingBottom: "10px",
      paddingTop: "10px",
      marginTop: "10px",
      marginBottom: "10px",
    },
    title: {
      marginBottom: 20,
    },
  })
);

type AccordionNavProps = {
  title?: string;
  mobile?: boolean;
  children: React.ReactNode;
  expanded?: boolean;
};

const AccordionNav = ({
  title,
  mobile,
  children,
  expanded,
}: AccordionNavProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const breakpoint = useMediaQuery(theme.breakpoints.down("sm"));

  const [isExpanded, setIsExpanded] = React.useState(expanded);

  const handleChange =
    () => (_event: React.ChangeEvent<{}>, _newExpanded: boolean) => {
      setIsExpanded(!isExpanded);
    };

  return (
    <>
      {breakpoint ? (
        <Accordion
          square
          className={classes.root}
          expanded={isExpanded}
          onChange={handleChange()}
        >
          <AccordionSummary
            className={classes.acordionSummary}
            expandIcon={<ExpandMoreIcon className={classes.icon} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {title ? (
              <Typography className={classes.heading}>{title}</Typography>
            ) : null}
          </AccordionSummary>
          <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
      ) : (
        <Card className={classes.root}>
          <CardContent>
            <Typography variant="h5" gutterBottom className={classes.title}>
              {mobile ? null : title}
            </Typography>
            {children}
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default AccordionNav;
